import React, { FC, useEffect } from "react";

// UI
import { Box } from "@UI/Components/Box/Box";
import { Text } from "@UI/Components/Text/Text";
import { Input } from "@UI/Components/Input/Input";

// Component
import { StripeCreditCardNumberForm } from "./StripeCreditCardNumberForm";

// Messages
import messages from "./messages";

// i18n
import useI18n from "@I18n/hooks/useI18n";
import {
  FormattedMessage,
  MessageDescriptor,
} from "@I18n/Components/FormattedMessage/FormattedMessage";
import { useStripeCreditCardForm } from "../../../hooks/stripe/useStripeCreditCardForm";
import { StripeError } from "@stripe/stripe-js";

// hooks

interface Props {
  onNameChange: (name: string) => void;
  setStripeError: (error: StripeError | undefined) => void;
  stripeError: MessageDescriptor;
  cleanError: () => void;
  onCompleted: () => void;
}

export const StripeCreditCardForm: FC<Props> = ({
  onNameChange,
  setStripeError,
  stripeError,
  onCompleted,
  cleanError,
}) => {
  const { formatMessage } = useI18n();

  const {
    setCreditCardNumberCompleted,
    onTextInputChange,
    nameCompleted,
    name,
    creditCardNumberCompleted,
  } = useStripeCreditCardForm();

  useEffect(() => {
    onNameChange(name);
  }, [name]);

  const showNameMissing = !nameCompleted && creditCardNumberCompleted;

  useEffect(() => {
    if (nameCompleted && creditCardNumberCompleted) {
      onCompleted();
    }
  }, [nameCompleted, creditCardNumberCompleted]);

  return (
    <>
      <Box data-testid={"card-holder"}>
        <Text color="gray.700" mb={2}>
          <FormattedMessage {...messages.cardOwner} />
        </Text>
        <Input
          borderColor={showNameMissing ? "red.700" : undefined}
          placeholder={formatMessage(messages.firstNameLastName)}
          size="md"
          onChange={onTextInputChange}
          name="card_holder_name"
          data-testid="cardholder-name-input"
        />
        {showNameMissing && (
          <Text color="red.700" mt={2}>
            <FormattedMessage {...messages.incompleteName} />
          </Text>
        )}
      </Box>
      <Box>
        <Text color="gray.700" mb={2}>
          <FormattedMessage {...messages.infoCard} />
        </Text>
        <StripeCreditCardNumberForm
          setCreditCardNumberCompleted={setCreditCardNumberCompleted}
          error={!!stripeError}
          cleanError={cleanError}
          setStripeError={setStripeError}
        />
        {!!stripeError && (
          <Text color="red.700" mt={2}>
            <FormattedMessage {...stripeError} />
          </Text>
        )}
      </Box>
    </>
  );
};
